// extracted by mini-css-extract-plugin
export var avatarContainer = "_dq-0";
export var gray = "_dq-f";
export var green = "_dq-c";
export var icon = "_dq-9";
export var image = "_dq-1";
export var lg = "_dq-6";
export var md = "_dq-5";
export var presenceDot = "_dq-b";
export var red = "_dq-d";
export var sm = "_dq-4";
export var status = "_dq-a";
export var xl = "_dq-7";
export var xs = "_dq-3";
export var xxl = "_dq-8";
export var xxs = "_dq-2";
export var yellow = "_dq-e";